import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { PencilIcon } from "lucide-react";
import { useState } from "react";
import TaxTypePrefixForm from "../../modal/my-business/other-settings-form";

interface OtherSettingsProps {
  setting?: Record<string, string>,
  title: string,
  refetch: () => void
}

export default function OtherSettings({ setting, title, refetch }: OtherSettingsProps) {
  const [isOpen, setOpen] = useState(false);
  const [action, setAction] = useState<"add" | "edit">("add");
  const [data, setData] = useState<Record<string, string> | undefined>(setting);

  const handleEdit = () => {
    console.log("Edit notification:", setting);
    setAction("edit");
    setData(setting);
    setOpen(true);
    // Add your edit logic here
  };


  return (
    <Card className="w-full ">
      <CardHeader className="flex flex-row items-center justify-between px-6 py-2">
        <CardTitle>Other Settings</CardTitle>
        <Button
          size="icon"
          variant="ghost"
          className="rounded-lg bg-primary p-2 shadow-sm hover:bg-primary/90 h-8 w-8"
          onClick={() => handleEdit()}

        >
          <PencilIcon className="h-4 w-4" />
        </Button>
      </CardHeader>
      <CardContent>
        <Separator className="h-[1px]" />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mt-2">
          <div className="space-y-1">
            <p className="text-xs ">Tax Type:</p>
            <p className="text-xs text-muted-foreground capitalize">{setting?.tax_type}</p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">Invoice Prefix</p>
            <p className="text-xs text-muted-foreground">{setting?.invoice_prefix}</p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">Member ID Prefix:</p>
            <p className="text-xs text-muted-foreground">{setting?.member_id_prefix}</p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">Coach ID Prefix:</p>
            <p className="text-xs text-muted-foreground">{setting?.coach_id_prefix}</p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">Staff ID Prefix</p>
            <p className="text-xs text-muted-foreground">{setting?.staff_id_prefix}</p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">Grace Period</p>
            <p className="text-xs text-muted-foreground">{setting?.grace_period} Days</p>
          </div>
        </div>
      </CardContent>
      <TaxTypePrefixForm
        editModeData={data}
        isOpen={isOpen}
        setOpen={setOpen}
        action={action}
        setAction={setAction}
        refetch={refetch}
      />
    </Card>
  );
}
